import { render, staticRenderFns } from "./account-card.vue?vue&type=template&id=231c7891&scoped=true&"
import script from "./account-card.vue?vue&type=script&lang=ts&"
export * from "./account-card.vue?vue&type=script&lang=ts&"
import style0 from "./account-card.vue?vue&type=style&index=0&id=231c7891&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c7891",
  null
  
)

export default component.exports